module.exports = __webpack_public_path__ + "img/Information-banner.cf50b129.jpg";